import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreDecinesCharpieu() {
  useEffect(() => {
    document.title = 'Décines-Charpieu Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Décines-Charpieu Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Décines-Charpieu. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CityHero 
          cityName="Décines-Charpieu"
          imageSeq="decines-charpieu-hero-011"
        />
        <Services />
        <Testimonials />
        <Contact />
        <FAQ />
        <Footer />
      </div>
    </>
  );
}
